module.exports = __webpack_public_path__ + "static/img/booking.c906004.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/booking.gif
// module id = NG/k
// module chunks = 0